import { c as _c } from "react/compiler-runtime";
import { IcoDotsHorizontal16 } from '@onefootprint/icons';
import type { ProxyConfigBasic } from '@onefootprint/request-types/dashboard';
import { Dropdown, IconButton } from '@onefootprint/ui';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PermissionGate from '@/components/permission-gate';
import type { RemoveHandler } from '../remove';
import Remove from '../remove';
import type { StatusHandler } from '../status';
import Status from '../status';
export type ActionsProps = {
  proxyConfig: ProxyConfigBasic;
};
const Actions = t0 => {
  const $ = _c(36);
  const {
    proxyConfig
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "actions"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("vault-proxy", t1);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const statusRef = useRef(null);
  const removeRef = useRef(null);
  const {
    name
  } = proxyConfig;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setDropdownOpen(false);
      statusRef.current?.toggle();
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleToggleStatus = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setDropdownOpen(false);
      removeRef.current?.remove();
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleRemove = t3;
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp2);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== name || $[6] !== t) {
    t5 = t(_temp3, {
      name
    });
    $[5] = name;
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <Dropdown.Trigger asChild={true}><div><IconButton aria-label={t5} size="tiny" className="max-md:size-10" icon={IcoDotsHorizontal16} /></div></Dropdown.Trigger>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <PermissionGate scopeKind="manage_vault_proxy" fallbackText={t4}>{t6}</PermissionGate>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== proxyConfig.status || $[14] !== t) {
    t8 = proxyConfig.status === "enabled" ? t(_temp4) : t(_temp5);
    $[13] = proxyConfig.status;
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <Dropdown.Item onSelect={handleToggleStatus}>{t8}</Dropdown.Item>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t(_temp6);
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10) {
    t11 = <Dropdown.Item onSelect={handleRemove} destructive={true}>{t10}</Dropdown.Item>;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t9) {
    t12 = <Dropdown.Portal><Dropdown.Content align="end"><Dropdown.Group>{t9}{t11}</Dropdown.Group></Dropdown.Content></Dropdown.Portal>;
    $[22] = t11;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== dropdownOpen || $[26] !== t12 || $[27] !== t7) {
    t13 = <Dropdown.Root open={dropdownOpen} onOpenChange={setDropdownOpen}>{t7}{t12}</Dropdown.Root>;
    $[25] = dropdownOpen;
    $[26] = t12;
    $[27] = t7;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  let t15;
  if ($[29] !== proxyConfig) {
    t14 = <Status proxyConfig={proxyConfig} ref={statusRef} />;
    t15 = <Remove proxyConfig={proxyConfig} ref={removeRef} />;
    $[29] = proxyConfig;
    $[30] = t14;
    $[31] = t15;
  } else {
    t14 = $[30];
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t13 || $[33] !== t14 || $[34] !== t15) {
    t16 = <button className="flex justify-end" type="button" onClick={_temp}>{t13}{t14}{t15}</button>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
};
export default Actions;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2($) {
  return $.notAllowed;
}
function _temp3($_0) {
  return $_0.ariaLabel;
}
function _temp4($_1) {
  return $_1.status.disable.cta;
}
function _temp5($_2) {
  return $_2.status.enable.cta;
}
function _temp6($_3) {
  return $_3.remove.cta;
}